var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2234 0.647949H1.77187C0.792187 0.647949 0 1.42139 0 2.37764V22.9136C0 23.8698 0.792187 24.6479 1.77187 24.6479H22.2234C23.2031 24.6479 24 23.8698 24 22.9183V2.37764C24 1.42139 23.2031 0.647949 22.2234 0.647949ZM7.12031 21.0995H3.55781V9.64326H7.12031V21.0995ZM5.33906 8.08232C4.19531 8.08232 3.27188 7.15889 3.27188 6.01982C3.27188 4.88076 4.19531 3.95732 5.33906 3.95732C6.47813 3.95732 7.40156 4.88076 7.40156 6.01982C7.40156 7.1542 6.47813 8.08232 5.33906 8.08232ZM20.4516 21.0995H16.8937V15.5308C16.8937 14.2042 16.8703 12.4933 15.0422 12.4933C13.1906 12.4933 12.9094 13.9417 12.9094 15.437V21.0995H9.35625V9.64326H12.7687V11.2089H12.8156C13.2891 10.3089 14.4516 9.35732 16.1813 9.35732C19.7859 9.35732 20.4516 11.7292 20.4516 14.8136V21.0995Z",
    fill: "#A4A7AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.647949)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.44628b1aa6fd03df946ee539e8bf8638.svg";
export { ForwardRef as ReactComponent };